import script from "./ArticleEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleEditor.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleEditor.vue?vue&type=style&index=0&id=f3f5c1e2&lang=scss"

const __exports__ = script;

export default __exports__